import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { ListOfPropertiesValues } from "./ListOfPropertiesValues";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { GENERAL_RULES_CONSTANTS } from "@/modules/GeneralRules/constants/GeneralRulesConstants";

export class TasksPropertiesValues extends ListOfPropertiesValues {
  affected = this.getUsers;
  formTemplate = this.getFormTemplates;
  responsible = this.getUsers;
  related = this.getUsers;
  createdBy = this.getUsers;
  changedBy = this.getUsers;
  dependencies = this.getDependenciesList;
  lastDocId = "";
  keyword = "";
  indexSectionOfDashboard = 0;
  indexCollection = 0;

  async loadItems(
    field: string,
    idList?: string,
    keyWord?: string,
    lastDocId?: string
  ) {
    this.lastDocId = lastDocId || "";
    if (keyWord) {
      return (await this[field as keyof TasksPropertiesValues](
        keyWord
      )) as DynamicSelectData[];
    }

    if (this.keyword) {
      this.keyword = "";
    }

    if (idList) {
      return this.getList(idList);
    }

    return await this[field as keyof TasksPropertiesValues]();
  }

  setIndexes(
    indexSectionOfDashboard: number,
    indexCollectionFilter: number
  ): void {
    this.indexSectionOfDashboard = indexSectionOfDashboard;
    this.indexCollection = indexCollectionFilter;
  }

  async getFormTemplates(keyword?: string) {
    try {
      return await this.getFormTemplatesCommonFunction(this.lastDocId, keyword);
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async getUsers(name?: string) {
    return await this.getUserByQuery(this.setFilters.bind(this), name);
  }

  setFilters(keyLastRef: string, name?: string) {
    const filterQuery: any = {
      state: GENERAL_RULES_CONSTANTS.ACTIVO
    };

    if (name && this.keyword !== name) {
      this.keyword = name;
      filterQuery.name = name;
      delete filterQuery[keyLastRef];
      return filterQuery;
    }

    if (name) {
      filterQuery.name = name;
      if (this.keyword !== name) {
        this.keyword = name;
      }
      return filterQuery;
    }

    return filterQuery;
  }

  async getDependenciesList() {
    return await this.getDependenciesListCommonFunction(this.lastDocId);
  }
}
